module.exports = __webpack_public_path__ + "static/assets/d925ccf215dcd4077e9e1a1f69a6dc81.png";